import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import Home from '../views/Home.vue'
// import start from '../views/index/start.vue'
import store from '../store'
import { Toast } from 'vant'
Vue.use(VueRouter)
  .use(Toast)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    redirect: '/home',
    children: [
      /**
       * 首页
       */
      {
        path: 'home',
        name: 'home',
        component: Home
      },
      {
        path: 'strength',
        name: 'Strength',
        component: () => import('@/views/Strength.vue')
      },
      {
        path: 'solution',
        name: 'Solution',
        component: () => import('@/views/Solution.vue')
      },
      {
        path: 'partner',
        name: 'Partner',
        component: () => import('@/views/Partner.vue')
      }
    ]
  }
]
// 路由守卫 权限认证
// const list = [
//   'Mine',
//   'Home',
//   'finance',
//   'Message',
//   'Cart',
//   'SubCategories'
// ]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 权限认证
router.beforeEach((to, from, next) => {
  store.commit('setShowBar', to.meta.showBar !== false)
  // if (!list.includes(to.name)) { // 访问的页面需要权限认证
  //   if (store.state.isLogin) { // 用户已登录，则继续访问
  //     next()
  //   } else { // 用户未登录，跳转到登录页面
  //     Toast.fail('用户未登录')
  //     setTimeout(function () {
  //       next({
  //         name: 'Login',
  //         params: { // 携带真实要跳转到的页面路径，以便在登录成功后继续向真实页面跳转
  //           to
  //         }
  //       })
  //     }, 1000)
  //   }
  // } else { // 不需要权限的页面
  //   next()
  // }
  next()
})
export default router
